import type { ZipCodeAddressItem } from '../types/vida/cep/cepType';
import { limitCidadeInput, limitLogradouroInput, limitUfInput } from './insuredFormUtils';

/** Suffix format returned by Vida (e.g. " - DE 1 ATE 99998"). Linear-time; no overlapping \\s quantifiers. */
const VIDA_STREET_RANGE_SUFFIX = / - DE \d+ ATE \d+$/i;

/** Removes the numeric range suffix returned by Vida (e.g. " - DE 1 ATE 99998"). */
export const normalizeZipCodeStreetName = (descrLogradouro: string): string =>
  descrLogradouro.replace(VIDA_STREET_RANGE_SUFFIX, '').trim();

export type ZipCodeAddressFormFields = {
  logradouro: string;
  bairro: string;
  cidade: string;
  uf: string;
};

export const mapZipCodeAddressItemToFormFields = (
  item: ZipCodeAddressItem,
): ZipCodeAddressFormFields => ({
  logradouro: limitLogradouroInput(normalizeZipCodeStreetName(item.descrLogradouro ?? '')),
  bairro: '',
  cidade: limitCidadeInput(item.descrCidade ?? ''),
  uf: limitUfInput(item.codEstado ?? ''),
});

import { cleanZipCode } from './zipCodeUtils';

export const isZipCodeComplete = (cep: string): boolean =>
  cleanZipCode(cep).length === 8;
